<div class="d-grid gap-3" style="grid-template-columns: 350px 1fr" *ngIf="viewType !== 'table'">
  <app-automation-wizard-left
    [type]="type"
    (typeChange)="typeChange.emit($event)"
    image="/assets/images/automation-wizards/invoice.webp"
  >
    <ng-container i18n
      >An invoice is a document detailing the charges for a booking or service provided. It includes actions such as
      sending the invoice for payment, following up on overdue payments, and notifying the property manager or guest of
      payment status. Managing invoices ensures accurate financial tracking and timely payments.</ng-container
    >
  </app-automation-wizard-left>
  <div class="card shadow">
    <div class="card-header flex-column align-items-start p-3 bg-default2">
      <h6 i18n>What would you like to do when an invoice is</h6>
      <div class="d-flex gap-3" [formGroup]="form">
        <div class="btn-group">
          <button
            type="button"
            (click)="onSelectEvent(events.InvoiceCreated)"
            class="btn btn-sm"
            [ngClass]="selectedEvent === events.InvoiceCreated ? 'btn-info' : 'btn-outline-light'"
            i18n
          >
            Manually Created
          </button>
          <button
            type="button"
            (click)="onSelectEvent(events.InvoicePaid)"
            class="btn btn-sm"
            [ngClass]="selectedEvent === events.InvoicePaid ? 'btn-info' : 'btn-outline-light'"
            i18n
          >
            Paid
          </button>
          <button
            type="button"
            (click)="onSelectEvent(events.InvoiceCanceled)"
            class="btn btn-sm"
            [ngClass]="selectedEvent === events.InvoiceCanceled ? 'btn-info' : 'btn-outline-light'"
            i18n
          >
            Canceled
          </button>
          <button
            type="button"
            (click)="onSelectEvent(events.TimeAfterInvoiceDue)"
            class="btn btn-sm"
            [ngClass]="selectedEvent === events.TimeAfterInvoiceDue ? 'btn-info' : 'btn-outline-light'"
            i18n
          >
            After Invoice Due
          </button>
        </div>
        <ng-container *ngIf="isTimeEvent">
          <app-automation-time-options
            [form]="form"
            [showLabel]="false"
            class="d-flex gap-3"
          ></app-automation-time-options>
        </ng-container>
      </div>
    </div>
    <div class="card-body d-flex flex-column gap-3">
      <ng-container [ngSwitch]="selectedEvent">
        <ng-template *ngSwitchCase="events.InvoiceCreated" [ngTemplateOutlet]="createdEvent"></ng-template>
        <ng-template *ngSwitchCase="events.InvoicePaid" [ngTemplateOutlet]="paidEvent"></ng-template>
        <ng-template *ngSwitchCase="events.InvoiceCanceled" [ngTemplateOutlet]="canceledEvent"></ng-template>
        <ng-template *ngSwitchCase="events.TimeAfterInvoiceDue" [ngTemplateOutlet]="afterOverdueEvent"></ng-template>
      </ng-container>
      <div class="flex-fill"></div>
      <app-automation-channel-rental-select
        [form]="form"
        [allowsChannel]="false"
      ></app-automation-channel-rental-select>
    </div>
  </div>
</div>

<div *ngIf="viewType === 'table'" class="d-flex flex-column gap-4 automation-table">
  <div class="table-view-header text-muted text-semi-bold">
    <div class="text-uppercase text-muted mb-0" i18n>What would you like to do when</div>
    <div i18n>Created Date • Time</div>
    <div i18n>Last Triggered Date • Time</div>
  </div>
  <div class="container-box shadow">
    <h6 class="text-uppercase m-0 px-3 py-2" i18n>Invoice is Manually Created</h6>
    <ng-template [ngTemplateOutlet]="createdEvent"></ng-template>
  </div>
  <div class="container-box shadow">
    <h6 class="text-uppercase m-0 px-3 py-2" i18n>Invoice is Paid</h6>
    <ng-template [ngTemplateOutlet]="paidEvent"></ng-template>
  </div>
  <div class="container-box shadow">
    <h6 class="text-uppercase m-0 px-3 py-2" i18n>Invoice is Canceled</h6>
    <ng-template [ngTemplateOutlet]="canceledEvent"></ng-template>
  </div>
  <div class="container-box shadow">
    <h6 class="text-uppercase m-0 px-3 py-2" i18n>After Invoice Due</h6>
    <ng-template [ngTemplateOutlet]="afterOverdueEvent"></ng-template>
  </div>
</div>

<ng-template #createdEvent>
  <app-do-action-automation
    [event]="events.InvoiceCreated"
    [type]="type"
    [viewType]="viewType"
    [eventSourceType]="type"
    [handler]="eventHandlers.InvoiceMarkPaidHandler"
    i18n-label
    i18n-name
    label="Mark Invoice as Paid"
    name="Mark Invoice as Paid when an invoice is created manually"
    [rentals]="form.get('rentals').value"
    [channels]="form.get('channels').value"
  ></app-do-action-automation>

  <app-do-action-automation
    [event]="events.InvoiceCreated"
    [type]="type"
    [viewType]="viewType"
    [eventSourceType]="type"
    [handler]="eventHandlers.InvoiceChargeHandler"
    i18n-label
    i18n-name
    label="Charge Invoice"
    name="Charge Invoice when an invoice is created manually"
    [rentals]="form.get('rentals').value"
    [channels]="form.get('channels').value"
  ></app-do-action-automation>

  <app-notify-handler-automation
    [event]="events.InvoiceCreated"
    [handler]="eventHandlers.InvoiceSendToGuestHandler"
    [viewType]="viewType"
    [eventSourceType]="type"
    i18n-label
    i18n-name
    label="Send invoice to guest"
    name="Send invoice to guest when an invoice is created manually"
    [messageSubject]="guestNotificationMessages[events.InvoiceCreated].subject"
    [messageBody]="guestNotificationMessages[events.InvoiceCreated].message"
    [rentals]="form.get('rentals').value"
    [channels]="form.get('channels').value"
  >
  </app-notify-handler-automation>
  <app-new-document-automation
    [event]="events.InvoiceCreated"
    [viewType]="viewType"
    [eventSourceType]="type"
    i18n-label
    i18n-name
    label="Send Document to Sign"
    name="Send document to sign when invoice created"
    [rentals]="form.get('rentals').value"
    [channels]="form.get('channels').value"
  ></app-new-document-automation>

  <app-do-action-automation
    [event]="events.InvoiceCreated"
    [type]="type"
    [viewType]="viewType"
    [eventSourceType]="type"
    [handler]="eventHandlers.SendToZapier"
    i18n-label
    i18n-name
    label="Send it to Zapier"
    name="Send it to Zapier when invoice created"
    [rentals]="form.get('rentals').value"
    [channels]="form.get('channels').value"
  ></app-do-action-automation>
</ng-template>

<ng-template #paidEvent>
  <app-do-action-automation
    [event]="events.InvoicePaid"
    [type]="automationTypes.Booking"
    [viewType]="viewType"
    [eventSourceType]="type"
    [handler]="eventHandlers.BookingMarkPaid"
    i18n-label
    i18n-name
    label="Update booking status to paid"
    name="Update booking status to paid when an invoice is paid"
    [rentals]="form.get('rentals').value"
    [channels]="form.get('channels').value"
  ></app-do-action-automation>

  <app-notify-guest-automation
    [event]="events.InvoicePaid"
    [viewType]="viewType"
    [eventSourceType]="type"
    i18n-label
    i18n-name
    label="Send payment confirmation to guest"
    name="Send payment confirmation to guest when an invoice is paid"
    [messageSubject]="guestNotificationMessages[events.InvoicePaid].subject"
    [messageBody]="guestNotificationMessages[events.InvoicePaid].message"
    [rentals]="form.get('rentals').value"
    [channels]="form.get('channels').value"
  >
  </app-notify-guest-automation>
  <app-new-document-automation
    [event]="events.InvoicePaid"
    [viewType]="viewType"
    [eventSourceType]="type"
    i18n-label
    i18n-name
    label="Send Document to Sign"
    name="Send document to sign when invoice is paid"
    [rentals]="form.get('rentals').value"
    [channels]="form.get('channels').value"
  ></app-new-document-automation>

  <app-do-action-automation
    [event]="events.InvoicePaid"
    [type]="type"
    [viewType]="viewType"
    [eventSourceType]="type"
    [handler]="eventHandlers.SendToZapier"
    i18n-label
    i18n-name
    label="Send it to Zapier"
    name="Send it to Zapier when invoice paid"
    [rentals]="form.get('rentals').value"
    [channels]="form.get('channels').value"
  ></app-do-action-automation>
</ng-template>

<ng-template #canceledEvent>
  <app-do-action-automation
    [event]="events.InvoiceCanceled"
    [type]="automationTypes.Booking"
    [viewType]="viewType"
    [eventSourceType]="type"
    [handler]="eventHandlers.BookingMarkUnpaid"
    i18n-label
    i18n-name
    label="Update booking status to unpaid"
    name="Update booking status to unpaid when an invoice is canceled"
    [rentals]="form.get('rentals').value"
    [channels]="form.get('channels').value"
  ></app-do-action-automation>
  <app-do-action-automation
    [event]="events.InvoiceCanceled"
    [type]="type"
    [viewType]="viewType"
    [eventSourceType]="type"
    [handler]="eventHandlers.SendToZapier"
    i18n-label
    i18n-name
    label="Send it to Zapier"
    name="Send it to Zapier when invoice canceled"
    [rentals]="form.get('rentals').value"
    [channels]="form.get('channels').value"
  ></app-do-action-automation>
</ng-template>

<ng-template #afterOverdueEvent>
  <app-notify-guest-automation
    [event]="events.TimeAfterInvoiceDue"
    [viewType]="viewType"
    [eventSourceType]="type"
    i18n-label
    i18n-name
    label="Send payment reminder to guest"
    name="Send payment reminder to guest after invoice is overdue"
    [messageSubject]="guestNotificationMessages[events.TimeAfterInvoiceDue].subject"
    [messageBody]="guestNotificationMessages[events.TimeAfterInvoiceDue].message"
    [days]="form.get('days').value"
    [hours]="form.get('hours').value"
    [rentals]="form.get('rentals').value"
    [channels]="form.get('channels').value"
  >
  </app-notify-guest-automation>

  <app-notify-users-automation
    [event]="events.TimeAfterInvoiceDue"
    [viewType]="viewType"
    [eventSourceType]="type"
    i18n-label
    i18n-name
    label="Notify the user(s)"
    name="Notify the user(s) after invoice is overdue"
    [messageSubject]="userNotificationMessages[events.TimeAfterInvoiceDue].subject"
    [messageBody]="userNotificationMessages[events.TimeAfterInvoiceDue].message"
    [days]="form.get('days').value"
    [hours]="form.get('hours').value"
    [rentals]="form.get('rentals').value"
    [channels]="form.get('channels').value"
  ></app-notify-users-automation>
  <app-do-action-automation
    [event]="events.TimeAfterInvoiceDue"
    [type]="type"
    [viewType]="viewType"
    [eventSourceType]="type"
    [handler]="eventHandlers.InvoiceCancelBookingHandler"
    i18n-label
    i18n-name
    label="Cancel the Booking"
    name="Cancel booking when invoice is overdue"
    [days]="form.get('days').value"
    [hours]="form.get('hours').value"
    [rentals]="form.get('rentals').value"
    [channels]="form.get('channels').value"
  ></app-do-action-automation>

  <app-do-action-automation
    [event]="events.TimeAfterInvoiceDue"
    [type]="type"
    [viewType]="viewType"
    [eventSourceType]="type"
    [handler]="eventHandlers.SendToZapier"
    i18n-label
    i18n-name
    label="Send it to Zapier"
    name="Send it to Zapier when invoice is overdue"
    [days]="form.get('days').value"
    [hours]="form.get('hours').value"
    [rentals]="form.get('rentals').value"
    [channels]="form.get('channels').value"
  ></app-do-action-automation>
</ng-template>
